export const SUPPORTED_CURRENCIES = ['ETB', 'USD', 'EUR', 'GBP'] as const;
export type SupportedCurrency = typeof SUPPORTED_CURRENCIES[number];

export const CURRENCY_SYMBOLS: Record<SupportedCurrency, string> = {
  ETB: 'ETB',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export const CURRENCY_NAMES: Record<SupportedCurrency, string> = {
  ETB: 'Ethiopian Birr',
  USD: 'US Dollar',
  EUR: 'Euro',
  GBP: 'British Pound',
};

export const DEFAULT_CURRENCY: SupportedCurrency = 'ETB';

// Valid ISO currency codes for Intl.NumberFormat
const validCurrencyCodes = new Set(['ETB', 'USD', 'EUR', 'GBP']);

/**
 * Format a number as currency with the specified currency code
 */
export function formatCurrency(amount: number, currency: string = 'ETB'): string {
  const currencyCode = currency || 'ETB';
  
  if (validCurrencyCodes.has(currencyCode)) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
    }).format(amount);
  }
  
  // Fallback for non-standard currencies
  return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2 })} ${currencyCode}`;
}

/**
 * Get the currency symbol for a given currency code
 */
export function getCurrencySymbol(currency: string): string {
  return CURRENCY_SYMBOLS[currency as SupportedCurrency] || currency;
}
